import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { isMobileOnly } from "react-device-detect";
import TruckSchedule from "./TruckSchedule";
import TruckScheduleMobile from "./TruckScheduleMobile";
import RestaurantSchedule from "./RestaurantSchedule";
import RestaurantScheduleMobile from "./RestaurantScheduleMobile";
import { Grid, Row, Col, FlexBox } from "~/components/.base/containers";
import { Subheading, BodyText, BodyTextAlt } from "~/components/.base/headings";
import {
	dayMap,
	monthMap,
} from "~/components/LocationPage/SearchPage/helper-objects.js";
import {
	formatTime,
	formatTitle,
	formatAddress,
} from "~/components/LocationPage/SearchPage/SearchResults/helpers";
import ClockIcon from "~/images/icons/location_clock.svg";
import "./DetailSchedule.scss";

const DetailSchedule = ({
	isATruck,
	calendarId,
	physicalAddress,
	restaurantSchedule,
}) => {
	const [scheduleData, setScheduleData] = useState([]);
	const [maxDepthArr, setMaxDepthArr] = useState([1]);
	const [weekDates, setWeekDates] = useState([]);
	useEffect(() => {
		if (calendarId) {
			axios
				.get(
					`https://lobster-staging.herokuapp.com/trucks/single-schedule?calendar_id=${calendarId}`
				)
				.then((res) => {
					console.log("CAL: ", res.data);
					setScheduleData(res.data[0].events);
					setMaxDepthArr(deriveMaxDepthArr(res.data[0].events));
				})
				.catch((err) => {
					console.log(err);
				});
		}
	}, [calendarId]);
	useEffect(() => {
		let weekDateArr = [];
		var curr = new Date(); // get current date
		var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
		for (let i = 0; i < 7; i++) {
			let d = new Date(curr);
			d.setDate(first + i);
			weekDateArr.push(d);
		}
		setWeekDates(weekDateArr);
	}, []);
	const deriveMaxDepthArr = (events) => {
		var maxLength = 1;
		for (let eventDay of Object.values(events)) {
			if (eventDay.length) {
				if (eventDay.length > maxLength) {
					maxLength = eventDay.length;
				}
			}
		}
		return new Array(maxLength).fill(1);
	};
	const formatDate = (date, cutSuffix) => {
		let suffix = "th";
		if (
			date.getDate() === 1 ||
			date.getDate() === 21 ||
			date.getDate() === 31
		) {
			suffix = "st";
		}
		if (date.getDate() === 2 || date.getDate() === 22) {
			suffix = "nd";
		}
		if (date.getDate() === 3 || date.getDate() === 23) {
			suffix = "rd";
		}
		return (
			<span>
				<span className="red">{dayMap[date.getDay()]}</span>
				<br />
				{monthMap[date.getMonth()].slice(0, 3)}{" "}
				{date.getDate() + suffix}
			</span>
		);
	};
	const formatDateMini = (date, cutSuffix) => {
		if (!date) return "";
		let suffix = "";
		if (cutSuffix) {
			suffix = "th";
			if (
				date.getDate() === 1 ||
				date.getDate() === 21 ||
				date.getDate() === 31
			) {
				suffix = "st";
			}
			if (date.getDate() === 2 || date.getDate() === 22) {
				suffix = "nd";
			}
			if (date.getDate() === 3 || date.getDate() === 23) {
				suffix = "rd";
			}
		}
		return (
			monthMap[date.getMonth()].slice(0, 3) +
			" " +
			date.getDate() +
			suffix
		);
	};
	return (
		<div className="detail-schedule">
			{isATruck ? (
				<Fragment>
					<Subheading className="schedule-title">
						Truck Schedule
					</Subheading>
					<Subheading className="schedule-title schedule-title-mobile">
						{formatDateMini(weekDates[0])} -{" "}
						{formatDateMini(weekDates[6])}
					</Subheading>
				</Fragment>
			) : (
				<Fragment>
					<Subheading className="schedule-title">Hours</Subheading>
					<BodyText className="schedule-hours">
						{physicalAddress}
					</BodyText>
					<Subheading md="2rem 0" className="schedule-title-mobile">
						Hours
					</Subheading>
				</Fragment>
			)}
			<div className="schedule-overflow">
				<Grid className="schedule-cont">
					<Row className="date-list">
						{weekDates.map((date, i) => (
							<Col size={1} key={i} className="week-date">
								<Subheading md="0">
									{formatDate(date)}
								</Subheading>
							</Col>
						))}
					</Row>
					{isATruck ? (
						<Fragment>
							<div className="mobile">
								<TruckScheduleMobile
									scheduleData={scheduleData}
									formatAddress={formatAddress}
									formatTitle={formatTitle}
									formatTime={formatTime}
									formatDateMini={formatDateMini}
									weekDates={weekDates}
								/>
							</div>
							<div className="desktop">
								<TruckSchedule
									scheduleData={scheduleData}
									formatAddress={formatAddress}
									formatTitle={formatTitle}
									formatTime={formatTime}
									maxDepthArr={maxDepthArr}
								/>
							</div>
						</Fragment>
					) : (
						<Fragment>
							<div className="mobile">
								<RestaurantScheduleMobile
									restaurantSchedule={restaurantSchedule}
									formatDate={formatDate}
									weekDates={weekDates}
								/>
							</div>
							<div className="desktop">
								<RestaurantSchedule
									restaurantSchedule={restaurantSchedule}
								/>
							</div>
						</Fragment>
					)}
				</Grid>
			</div>
		</div>
	);
};

export default DetailSchedule;
